import { Button, Form, Modal } from 'react-bootstrap'
import { DateTime } from 'luxon'
import { IoWarningOutline } from 'react-icons/io5'
import { z } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import Cart from '../../../types/cart'
import { api } from 'src/lib/axios'
import { useContext } from 'react'
import { CartsContext } from '@context/cart.ctx'
import { AppContext } from '@context/app.ctx'
import { stat } from 'fs'
import { PackageCartsData } from '@reducers/carts/reducer'


const CancelMottuSchema = z.object({
  orderId: z.string(),
  reason: z.string(),
})

type CancelMottuFormData = z.infer<typeof CancelMottuSchema>

interface CancelOrderMottuProps {
  cart: Cart
  show: boolean
  setShow: (data: any) => void
  taxMessage: boolean
  setSelectedOption?: (data: any) => void
}

export function ModalCancelOrderMottu({ cart, show, setShow, taxMessage, setSelectedOption }: CancelOrderMottuProps) {

  const { carts, setCarts, setPackageCarts, packageCarts } = useContext(CartsContext)
  const { handleShowToast } = useContext(AppContext)


  const { register, setValue, getValues, watch } = useForm({
    resolver: zodResolver(CancelMottuSchema),
    defaultValues: {
      orderId: cart.controls?.mottu?.orderId,
      reason: '',
    }
  })

  /**
   * Cancela uma entrega da Mottu.
   *
   * @param {{ body: any, cart: Cart }} - Corpo da requisi o e o carrinho.
   * @returns {Promise<{ data: any }>} - O resultado da requisição.
   */
  const cancelDeliveryMottu = async ({ body, cart }: { body: any, cart: Cart }) => {
    try {
      const { data } = await api.post('/dashboard/mottu/cancel', { body })
      const attCarts = carts.map((cart) => {
        const attCart = data.carts.find((attCart: Cart) => attCart.id === cart.id)
        return attCart ? { ...cart, ...attCart } : cart
      })

      if (cart.packageDate && packageCarts) {
        let newPackageCarts = {
          ...packageCarts,
          data: packageCarts.data.map((cart: Cart) => {
            const attCart = data.carts.find((attCart: Cart) => attCart.id === cart.id)
            return new Cart(attCart ? { ...cart, ...attCart } : cart)
          }),
        }
        setPackageCarts(newPackageCarts)
      }

      setCarts(attCarts)
      if (setSelectedOption) setSelectedOption('')

      setShow(false)
      handleShowToast({
        type: 'success',
        content: 'Cancelado com sucesso',
        title: 'Cancelamento',
      })
    } catch (error) {
      handleShowToast({
        type: 'erro',
        content: 'Falha no cancelamento',
        title: 'Cancelamento',
      })
      throw new Error('Não foi possível cancelar entrega da Mottu')
    }
  }

  return (
    <Modal
      show={show}
      centered
      onHide={() => {
        setShow(false)
      }}
      style={{ zIndex: 999999 }}
    >
      <Modal.Body >
        <div className='text-center' >
          <IoWarningOutline className='text-white p-1' style={{ height: '60px', width: '60px', backgroundColor: '#FBBF24', borderRadius: '6px' }} />
          <p className='fw-bold mt-2 fs-5' style={{ color: "#A35F32" }}>ATENÇÃO!</p>
        </div>
        <div className='text-center'>
          <p>Tem certeza que deseja cancelar a entrega? {cart.code}</p>
          {taxMessage ?
            <p>Será cobrada uma taxa de R$ 4,00.</p>
            :
            <p>Não haverá custo adicional para o cancelamento.</p>
          }
        </div>
        <Form.Group className="mb-3">
          <Form.Label>Razão de cancelamento</Form.Label>
          <Form.Control as="textarea" rows={1} {...register('reason')} />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="px-4 py-2"
          variant="secondary"
          onClick={() => {
            setShow(false)
            if (setSelectedOption) {
              setSelectedOption('mottu')
            }
          }}
        >
          <span>Manter Pedido</span>
        </Button>
        <Button
          className="px-4 py-2"
          variant="danger"
          onClick={() => {
            cancelDeliveryMottu({ body: getValues(), cart })
          }}
        >
          <span>Confirmar Cancelamento</span>
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
